import classNames from "classnames";
import React from "react";

export type CaNavigationOptionProps = {
  label: string;
  isActive?: boolean;
  href?: string;
  onClick?: () => void;
  enableBadge?: boolean;
  badge?: number;
  className?: string;
  style?: React.CSSProperties;
  fill?: boolean;
};

function CaNavigationOption({
  label,
  isActive,
  href,
  onClick,
  enableBadge,
  badge,
  className,
  style,
  fill,
}: CaNavigationOptionProps) {
  const Component = href ? "a" : "button";

  return (
    <Component
      className={classNames(
        "text-left text-deep-blue cursor-pointer flex text-base items-center justify-between hover:bg-light-neutral-4 border-none rounded-sm gap-2.5 px-5 py-2.5",
        isActive ? "bg-gradient-light text-purple font-bold" : "bg-transparent",
        fill && "w-full",
        className,
      )}
      style={style}
      href={href}
      onClick={onClick}
    >
      <span>{label}</span>
      {enableBadge && (
        <span
          className={classNames(
            "text-sm font-sans-serif font-semibold rounded-sm h-6 w-6 flex items-center justify-center",
            isActive ? "bg-purple text-white" : "border border-light-neutral-2",
          )}
        >
          {badge}
        </span>
      )}
    </Component>
  );
}

CaNavigationOption.defaultProps = {
  enableBadge: false,
  badge: 0,
  onClick: () => {},
  href: undefined,
  className: "",
  style: {},
  isActive: false,
  fill: false,
};

export default CaNavigationOption;
